import React from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { usePublicTheme } from "@/contexts/ThemeContext";

export const PublicLayout = ({ children }) => {
  const { theme } = usePublicTheme();
  return (
    <div
      data-testid="public-root"
      data-theme={theme}
      className={`${theme === "dark" ? "coh-dark" : ""} min-h-screen flex flex-col bg-[color:var(--coh-paper)] text-[color:var(--coh-ink)]`}
    >
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className="flex-1 outline-none">{children}</main>
      <SiteFooter />
    </div>
  );
};
